import React, { Component } from "react";
import {LocalForm, Errors, Control} from "react-redux-form";

export default class UserReset extends Component{
	render(){
		const required = (val) => val && val.length;
		return(
			<div>
				<p className="is-size-5 has-text-centered">Restablecer Contraseña</p>
				{this.props.message && <p className="has-text-centered help is-success">{this.props.message}</p>}
				{this.props.error && <p className="has-text-centered help is-danger">{this.props.error}</p>}
				<br/>
				<LocalForm model="reset" onSubmit={(val) => this._handleSubmit(val)}
				           validators={{
					           '': {passwordsMatch: (vals) => vals.password === vals.password_confirmation}
				           }}>
					<div className="field">
						<div className="control has-icon has-icon-left">
							<Control.text type="email" model=".username" className="input" placeholder="Usuario" autoFocus={true} validators={{required}} />
							<span className="icon is-small is-left"><i className={`fa fa-envelope`} /></span>
						</div>
						<Errors className="help is-danger" model=".username" show="touched" messages={{required: 'Tu usuario es requerido', typeMismatch: 'El usuario que ingresaste es inválido'}} />
					</div>
					<div className="field">
						<div className="control has-icon has-icon-left">
							<Control.password model=".password" className="input" placeholder="Contraseña" validators={{required}} />
							<span className="icon is-small is-left"><i className={`fa fa-lock`} /></span>
						</div>
						<Errors className="help is-danger" model=".password" show="touched" messages={{required: 'Tu contraseña es requerida'}} />
					</div>
					<div className="field">
						<div className="control has-icon has-icon-left">
							<Control.password model=".password_confirmation" className="input" placeholder="Confirmar Contraseña" validators={{required}} />
							<span className="icon is-small is-left"><i className={`fa fa-lock`} /></span>
						</div>
						<Errors className="help is-danger" model=".password_confirmation" show="touched" messages={{required: 'La confirmación de tu contraseña es requerida'}} />
					</div>
					<Errors model="reset" show="touched" messages={{passwordsMatch: 'La confirmación de la contraseña no coincide'}} wrapper={(props) => <p className="has-text-danger">{props.children}</p>} />
					<p className="has-text-right">
						<button className="button is-black">
							<span>Restablecer</span>
							<span className="icon is-small"><i className="fa fa-sign-in"></i></span>
						</button>
					</p>
				</LocalForm>
				<p className="has-text-left">
					<button onClick={() => this.props.setActionType('login')} className="button is-small is-link">Regresar</button>
				</p>
			</div>
		)
	}

	_handleSubmit(values){
		this.props.userReset(values, this.props.query);
		this.props.setActionType('login');
	}
}


// WEBPACK FOOTER //
// ./src/elements/login/userResetPassword.jsx